var cov_2aqikr9xn9 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/Checkbox.ts",
      hash = "7c8c6573d967e1d61473a3f4faa787604fc71eec",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Checkbox/Checkbox.ts",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 17
        },
        end: {
          line: 3,
          column: 38
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import checkItem from './CheckItem';
var Checkbox = (cov_2aqikr9xn9.s[0]++, checkItem('checkbox'));
export default Checkbox;